import ISalePricing from "../contracts/ISalePricing";
import PricingHandler from "../contracts/PricingHandler";
import IResolvedPricing from "../contracts/IResolvedPricing";

/**
 * Assigns price to sale price if it is lower than the resolved price.
 *
 * @param input
 * @param resolvedPricing
 */
const saleHandler: PricingHandler<ISalePricing> = (input, resolvedPricing) => {
  if (!input.salePrice || resolvedPricing.price <= input.salePrice) {
    return resolvedPricing;
  }

  return {
    ...resolvedPricing,
    metadata: {
      ...resolvedPricing.metadata,
      originalPrice: resolvedPricing.price,
    },
    price: input.salePrice,
  } as IResolvedPricing;
};

export default saleHandler;
